
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from './use-toast';

interface UpdateBookParams {
  id: string;
  title: string;
  isbn: string;
  publishDate: string;
  authorId: string;
  format: string;
}

export const useUpdateBook = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async (bookData: UpdateBookParams) => {
      const { data, error } = await supabase
        .from('books')
        .update({
          title: bookData.title,
          isbn: bookData.isbn,
          publish_date: bookData.publishDate,
          author_id: bookData.authorId,
          format: bookData.format,
        })
        .eq('id', bookData.id)
        .select()
        .single();

      if (error) {
        toast({
          title: 'Error updating book',
          description: error.message,
          variant: 'destructive',
        });
        throw error;
      }

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['books'] });
      toast({
        title: 'Success',
        description: 'Book has been updated successfully.',
      });
    },
  });
};
